import styles from 'src/components/Sidebar/sidebar.module.scss'

/**
 * Sets a given class to targeted parent for opening and closing certain components.
 * @param currentElement
 * @param wrapperSelector
 * @param wrapperClass
 */
function setWrapperClass(currentElement, wrapperSelector, wrapperClass) {
    if (!currentElement || !wrapperSelector || !wrapperClass) {
        return
    }
    const showClass = styles[wrapperClass]
    const transitionClass = styles[`${wrapperClass}Transitioning`]

    // Check if filter panel is open and close it

    const wrapperElement = currentElement.closest(wrapperSelector)
    const removeClass = function () {
        wrapperElement.classList.remove(transitionClass)
    }

    wrapperElement.addEventListener('transitionend', removeClass)
    wrapperElement.classList.add(transitionClass)

    if (wrapperElement.classList.contains(showClass)) {
        wrapperElement.classList.remove(showClass)
    } else {
        wrapperElement.classList.add(showClass)
    }
}

export default setWrapperClass
